import React, {PureComponent} from 'react'
import cn from 'classnames'
import injectSheet from 'react-jss'
import Heading from "../Widgets/Heading"
import {UnstyledLink} from "../Widgets/Link"
import ImageOrVideo from '../Widgets/ImageOrVideo'
import Summary from "../Widgets/Summary"
import flow from 'lodash/flow'
import CategoryLabelAndTime from '../Widgets/CategoryLabelAndTime'

const LARGE_CARD_SIZE = 'large';
const LARGE_CARD_HEADING_TAG = 'h1';
const STANDARD_CARD_HEADING_TAG = 'h2';

const headingTagForCardSize = size => size === LARGE_CARD_SIZE ? LARGE_CARD_HEADING_TAG : STANDARD_CARD_HEADING_TAG;

class ArticleCard extends PureComponent {

    render() {
        const {classes, className, children,
            cardClassName, size = LARGE_CARD_SIZE, headingTag = headingTagForCardSize(size), dividerSpacing = 'small', image, video,
            imageAspect, showArticleMeta = true, showArticleTime, showSummary = true,
            clampSummary=2, fakeLink, article,
            hoverEffect=true,
            blurEnabled=true,
            dataCy='articleCardContainer'} = this.props;
        const {title, link, subtitle, summary} = article;

        return <UnstyledLink className={cn(classes.link, size, className, {hover: hoverEffect})} link={link} fake={fakeLink} data-cy={dataCy}>
            {video && (
              <div className={classes.videoThumbIcon}><span className={classes.videoThumbIconTriangle}></span></div>
            )}
            {(image || video) &&
              <ImageOrVideo images={image} video={video} aspect={imageAspect} className={classes.image} blurEnabled={blurEnabled} videoPaused={true} />
            }
            <div className={cn(classes.cardContainer, {
                [classes.smallCard]: size === 'small',
                [classes.mediumCard]: size === 'medium',
            }, cardClassName)} >
                {showArticleMeta && (<CategoryLabelAndTime article={article} className={classes.categoryContainer} showArticleTime={showArticleTime} showYear={false} size={size} dividerSpacing={dividerSpacing} />)}
                <div className={classes.titleContainer} data-cy="articleCardHeadingContainer">
                  <Heading tag={headingTag} className={cn(classes.title, {[classes.titleWithSummary]: showSummary && (subtitle || summary)})}>{title}</Heading>
                </div>
                { (showSummary && (subtitle || summary)) && <Summary className={cn(classes.summary, className.summary)} summary={subtitle || summary} clamp={clampSummary} />}
                {children}
            </div>
        </UnstyledLink>
    }
}

export default flow([
  injectSheet( theme => ({
    link: {
      textDecoration: 'none',
      display: 'block',
      cursor: 'pointer',
      overflow: 'hidden',
      boxShadow: '0 0 16px 1px rgba(0, 0, 0, 0.05)',
      position: 'relative',
      transition: 'box-shadow 0.15s ease-out, transform 0.15s ease-out',
      '&:hover, &.hover:hover': {
        textDecoration: 'none',
        transform: 'scale(1.03)',
        boxShadow: 'none'
      },
      [theme.breakpoint('mobile')]: {
        overflow: 'visible',
        borderRadius: 0,
        boxShadow: 'none',
      },
    },
    cardContainer: {
      backgroundColor: theme.colors.white,
      boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.10)',
      display: 'block',
      textDecoration: 'none',
      flexGrow: 1,
      overflow: 'hidden',
      padding: theme.ds.spacing(3),
      margin: [-3, 0, 0], // -3 to cover up the border radius
      [theme.breakpoint('mobile')]: {
        padding: theme.ds.spacing(3),
        margin: [`-${theme.spacing.normal}`, theme.ds.spacing(4), 0, 0],
      },
      [theme.breakpoint('laptop')]: {
        padding: 40
      },
      position: 'relative',
    },
    smallCard: {
      padding: theme.ds.spacing(3),
    },
    mediumCard: {
      padding: theme.ds.spacing(3),
    },
    titleContainer: {
      position: "relative",
      display: "block",
      [theme.breakpoint("tablet")]: {
        display: "flex",
        flexDirection: "row",
      }
    },
    title: {
      marginBottom: 0,
      textTransform: 'none',
      flex: "1 1 100%",
      lineHeight: 1.25,
      marginTop: 12,
      fontSize: theme.getRemValue(20),
      [theme.breakpoint('tablet')]: {
        fontSize: theme.getRemValue(32)
      },
      '$smallCard &, $mediumCard &': {
        marginTop: 0,
        ...theme.font.familyBoldStyle,
        fontSize: theme.getRemValue(16),
        lineHeight: 1.25,
        letterSpacing: 0.3
      }
    },
    titleWithSummary: {
      marginBottom: theme.spacing.small,
      '$smallCard &, $mediumCard &': {
        marginBottom: theme.getRemValue(7),
      }
    },
    categoryContainer: {
      marginBottom: '0.3rem'
    },
    category: {
      fontWeight: 600,
      textTransform: 'uppercase',
      fontFamily: theme.font.info.fontFamily,
      lineHeight: theme.font.info.lineHeight,
      fontSize: theme.getRemValue(10),
      //color: ({article: {category}}) => theme.colors[category.toLowerCase()] || theme.colors.trending,
    },
    summary: {
      color: theme.colors.black,
      '& p': {
        fontFamily: theme.font.titleFontFamily,
        fontSize: theme.getRemValue(14),
        fontStyle: "italic",
        lineHeight: 1.5,
        '$smallCard &, $mediumCard &': {
          fontFamily: theme.font.family,
          fontStyle: 'normal',
          fontSize: theme.getRemValue(16),
          lineHeight: 1.5,
        },
        [theme.breakpoint('tablet')]: {
          fontSize: theme.getRemValue(20),
          lineHeight: 1.5,
        }
      },
      '& p:last-child': {
        margin: 0,
      }
    },
    videoThumbIcon: {
      top: 0,
      right: 0,
      width: 36,
      height: 36,
      position: 'absolute',
      backgroundColor: 'rgba(0,0,0,0.8)',
      zIndex: 99,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    videoThumbIconTriangle: {
      border: 0,
      background: 'transparent',
      boxSizing: 'border-box',
      width: 0,
      borderColor: 'transparent transparent transparent #fff',
      borderStyle: 'solid',
      borderWidth: '6px 0 6px 10px',
      marginLeft: 3
    }
  }))
])(ArticleCard)





// WEBPACK FOOTER //
// ./src/components/Card/ArticleCard.js